export default __webpack_public_path__ + "static/media/logo.ef36b089.png";